var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-development"},[_c('div',{staticClass:"modal-development__title"},[_vm._v(" Этот раздел в разработке ")]),_c('div',{staticClass:"modal-development__text"},[_vm._v(" Приносим извинения за доставленные неудобства. Вы можете написать о своей проблеме нам на почту ")])])
}]

export { render, staticRenderFns }